import React from 'react';

const UpArrow  = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill" d="M18 15.11L5.555 27.555 2 24 18 8l16 16-3.555 3.555L18 15.11z" fill={fill}/>
    </svg>
);

export default UpArrow;